import { useState } from 'react'
import { portfolioItems, portfolioCategories } from '../../data/portfolio'
import './Portfolio.css'

function GalleryItem({ item }) {
  const [lightboxOpen, setLightboxOpen] = useState(false)

  return (
    <>
      <article
        className="gallery__item"
        aria-label={item.title}
        onClick={() => item.image && setLightboxOpen(true)}
        style={{ cursor: item.image ? 'pointer' : 'default' }}
      >
        <div className="gallery__item-image">
          {item.image ? (
            <img
              src={item.image}
              alt={item.alt}
              width={item.width}
              height={item.height}
              loading="lazy"
            />
          ) : (
            <div className="gallery__item-placeholder" aria-hidden="true">
              <span>🖊️</span>
              <p>{item.title}</p>
            </div>
          )}
        </div>
        <div className="gallery__item-info">
          <span className="gallery__item-category">{item.category}</span>
          <h3 className="gallery__item-title">{item.title}</h3>
        </div>
        {item.image && (
          <div className="gallery__item-hover" aria-hidden="true">
            <span>View</span>
          </div>
        )}
      </article>

      {/* Simple lightbox */}
      {lightboxOpen && (
        <div
          className="lightbox"
          role="dialog"
          aria-modal="true"
          aria-label={`Full size view of ${item.title}`}
          onClick={() => setLightboxOpen(false)}
        >
          <button
            className="lightbox__close"
            onClick={() => setLightboxOpen(false)}
            aria-label="Close image viewer"
          >
            ✕
          </button>
          <img src={item.image} alt={item.alt} className="lightbox__image" />
          <p className="lightbox__caption">{item.title} — {item.category}</p>
        </div>
      )}
    </>
  )
}

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState('All')

  const filtered =
    activeCategory === 'All'
      ? portfolioItems
      : portfolioItems.filter((item) => item.category === activeCategory)

  return (
    <section className="portfolio section" aria-labelledby="portfolio-heading">
      <div className="container">
        {/* Header */}
        <div className="portfolio__header">
          <span className="portfolio__eyebrow">The Work</span>
          <h2 className="portfolio__heading" id="portfolio-heading">
            Portfolio
          </h2>
          <p className="portfolio__intro">
            Every piece is a conversation between artist and client. Browse the gallery
            below to see what's possible.
          </p>
        </div>

        {/* Filter tabs */}
        <div
          className="portfolio__filters"
          role="group"
          aria-label="Filter portfolio by style"
        >
          {portfolioCategories.map((cat) => (
            <button
              key={cat}
              className={`portfolio__filter-btn${activeCategory === cat ? ' portfolio__filter-btn--active' : ''}`}
              onClick={() => setActiveCategory(cat)}
              aria-pressed={activeCategory === cat}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Gallery grid */}
        <div
          className="gallery__grid"
          role="list"
          aria-live="polite"
          aria-label={`Gallery — ${filtered.length} items`}
        >
          {filtered.map((item) => (
            <div key={item.id} role="listitem">
              <GalleryItem item={item} />
            </div>
          ))}
        </div>

        {filtered.length === 0 && (
          <p className="portfolio__empty">No items in this category yet. Check back soon!</p>
        )}

        {/* CTA */}
        <div className="portfolio__cta-wrap">
          <p className="portfolio__cta-note">
            Want to see more? Follow{' '}
            <a
              href="https://instagram.com/jessebtatoos"
              target="_blank"
              rel="noopener noreferrer"
              className="portfolio__ig-link"
            >
              @jessebtatoos on Instagram
            </a>{' '}
            for the latest work.
          </p>
        </div>
      </div>
    </section>
  )
}
